module.exports = __webpack_public_path__ + "img/v4_no_search.91595142.png";